import { FC, useState } from "react";
import { AppButton } from "site/ui";
import { useQuizStore } from "store";
import styled from "styled-components";

const ConfirmationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 24px 0;
  font-family: "Manrope", sans-serif;
`;

const WarningIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #fef3c7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  &:before {
    content: "!";
    font-size: 24px;
    font-weight: bold;
    color: #f59e0b;
  }
`;

const ConfirmationTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 8px;
`;

const ConfirmationDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 24px;
`;

const ConfirmationButtons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`;
export interface QuizPauseStateProps {
}
export const QuizPauseState:FC<QuizPauseStateProps> = ({}) => {
  const { abandonQuiz } = useQuizStore();
  return (
    <ConfirmationContainer>
        <WarningIcon />

        <ConfirmationTitle>
            Are you sure you want to leave your quiz?
        </ConfirmationTitle>
        <ConfirmationDescription>
            You can choose to abandon this quiz and lose your progress, or
            pause and continue from where you left off.
        </ConfirmationDescription>

        <ConfirmationButtons>
            <AppButton variant="secondary" onClick={abandonQuiz}>
            Abandon quiz
            </AppButton>

            <AppButton variant="primary" onClick={abandonQuiz}>
            Pause and leave
            </AppButton>
        </ConfirmationButtons>
    </ConfirmationContainer>
  );
}